import React, { Component } from "react";
import { Link } from "react-router-dom";
import { URL_KKN_JOENSUU } from "../../../url/index";
import { withTranslation } from "react-i18next";

class ServicesHome extends Component {
  render() {
    const { t } = this.props;
    
    const cardStyle = {
      height: "100%",
      overflow: "hidden",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      maxWidth: "400px",
      margin: "0 auto"
    };
    
    const imageStyle = {
      height: "180px",
      objectFit: "cover",
      display: "block",
      width: "100%"
    };
    
    const cardInfoStyle = {
      padding: "0.6rem",
      textAlign: "center",
      background: "#052324"
    };
    
    const cardTitleStyle = {
      fontSize: "0.9rem",
      fontWeight: "600",
      margin: "0.3rem 0",
      lineHeight: "1.4",
      color: " #ffc905"
    };
    
    const btnStyle = {
      marginTop: "0.3rem",
      padding: "0.3rem 0.8rem",
      fontSize: "0.85rem"
    };
    
    return (
    
        <div className="container py-3">
          <h3 className="heading text-center mb-4">
            {t("servicesH.title")}
          </h3>
          <div className="row g-3">
            <div className="col-sm-6 col-lg-6">
              <div style={cardStyle}>
                <Link to="/Gallery">
                  <img
                    src="assets/images/services2.jpg"
                    alt="haircut services"
                    className="img-fluid"
                    style={imageStyle}
                  />
                </Link>
                <div style={cardInfoStyle}>
                  <h5 style={cardTitleStyle}>{t("servicesH.photoa")}</h5>
                  <a
                    href={URL_KKN_JOENSUU}
                    className="read-more two btn btn-sm"
                    style={btnStyle}
                  >
                    <span className="fa fa-arrow-circle-o-right"></span>
                  </a>
                </div>
              </div>
            </div>
            
            <div className="col-sm-6 col-lg-6">
              <div style={cardStyle}>
                <Link to="/Gallery">
                  <img
                    src="assets/images/services1.jpg"
                    alt="beard trimming services"
                    className="img-fluid"
                    style={imageStyle}
                  />
                </Link>
                <div style={cardInfoStyle}>
                  <h5 style={cardTitleStyle}>{t("servicesH.photob")}</h5>
                  <a
                    href={URL_KKN_JOENSUU}
                    className="read-more two btn btn-sm"
                    style={btnStyle}
                  >
                    <span className="fa fa-arrow-circle-o-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
  
    );
  }
}

export default withTranslation("global")(ServicesHome);
